export enum Status {
  CANCELLED = 'cancelled',
  ERROR = 'error',
  PROCESSING = 'processing',
  SUCCESS = 'success',
}